import React from 'react';
import Icon from '../AppIcon';
import { useLanguage } from '../../contexts/LanguageContext';

const LanguageSwitcher = () => {
  const { language, setLanguage } = useLanguage();

  const toggleLanguage = () => {
    const newLanguage = language === 'en' ? 'zh' : 'en';
    setLanguage(newLanguage);
  };

  return (
    <button
      onClick={toggleLanguage}
      className="flex items-center gap-2 px-3 py-2 rounded-md border border-border hover:bg-muted transition-smooth text-sm font-medium"
      aria-label={`Switch to ${language === 'en' ? 'Chinese' : 'English'}`}
    >
      <Icon name="Languages" size={18} />
      <span className="hidden sm:inline">{language === 'en' ? 'EN' : '中文'}</span>
    </button>
  );
};

export default LanguageSwitcher;